<template>
  <div>
    <v-data-table
      ref="table-conv"
      :loading="loading"
      loading-text="Loading..."
      :headers="headers"
      :items="items"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      fixed-header
      hide-default-footer
      class="elevation-1"
      :items-per-page="9999"
    >
      <template v-slot:item="props">
        <tr
          :index="items.indexOf(props.item)"
          :class="indexRow === items.indexOf(props.item) ? 'row-active' : ''"
          class="cursor-pointer"
          v-on:click="rowClick(props.item)"
        >
          <td>
            {{ props.item.name }}
          </td>
          <td>
            <div class="text-right">{{ props.item.visit | decimalFormat }}</div>
          </td>
          <td>
            <div class="text-right">{{ props.item.percent_visit }}%</div>
          </td>
          <td>
            <div class="text-right">{{ props.item.exit | decimalFormat }}</div>
          </td>
          <td>
            <div class="text-right">{{ props.item.percent_exit }}%</div>
          </td>
        </tr>
      </template>

      <template v-if="items.length < 2" v-slot:body>
        <tbody>
          <tr class="v-data-table__empty-wrapper">
            <td class="text-center" :colspan="5">No data available</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    loading: Boolean,
    items: {
      type: Array,
      default: () => []
    },
    nameSelected: String
  },
  watch: {
    items: {
      immediate: true,
      deep: true,
      handler() {
        if (this.items.length > 1) {
          setTimeout(() => {
            const row = document.getElementsByTagName('tr')[1]
            const index = row.getAttribute('index')
            this.rowClick(this.items[index])
          }, 200)
        }
      }
    },
    nameSelected: {
      handler(val) {
        const index = _.findIndex(this.items, { name: val })
        this.rowClick(this.items[index])
      }
    }
  },
  data() {
    return {
      headers: [
        {
          text: 'Checkpoint',
          value: 'name',
          align: 'start',
          sortable: true
        },
        {
          text: 'Visit',
          value: 'visit',
          align: 'right',
          sortable: true,
          width: '90px'
        },
        {
          text: '%Visit',
          value: 'percent_visit',
          align: 'right',
          sortable: true,
          width: '90px'
        },
        {
          text: 'Exit',
          value: 'exit',
          align: 'right',
          sortable: true,
          width: '90px'
        },
        {
          text: '%Exit',
          value: 'percent_exit',
          align: 'right',
          sortable: true,
          width: '90px'
        }
      ],
      sortBy: ['visit'],
      sortDesc: [true],
      indexRow: -1
    }
  },
  methods: {
    rowClick(item) {
      this.indexRow = this.items.indexOf(item)
      setTimeout(() => {
        this.$emit('getDetail', item)

        setTimeout(() => {
          const row = document.getElementsByClassName('row-active')[0]
          const parent = this.$refs['table-conv'].$el.firstChild

          this.scrollParentToChild(parent, row)
        }, 100)
      }, 200)
    },
    scrollParentToChild(parent, child) {
      const parentRect = parent.getBoundingClientRect()
      const parentViewableArea = {
        height: parent.clientHeight,
        width: parent.clientWidth
      }
      const childRect = child.getBoundingClientRect()
      const isViewable =
        childRect.top >= parentRect.top &&
        childRect.top <= parentRect.top + parentViewableArea.height
      if (!isViewable) {
        parent.scrollTop =
          childRect.top +
          parent.scrollTop -
          parentRect.top -
          childRect.height -
          10
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-data-table {
  border: unset !important;
}

::v-deep .v-data-table__wrapper {
  // min-height: 150px !important;
  height: calc(100vh - 160px) !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td {
  height: 37px !important;
  padding: 0 7px !important;
}

.v-data-table > .v-data-table__wrapper > table > thead > .head1 > th {
  border-top: unset !important;
  border-right: unset !important;
  border-left: unset !important;
  background-color: white !important;
}

.selected {
  font-weight: 700;
  color: #333333;
}
</style>
